export const StudentStatusValues = Object.freeze({
  OFF_QUEUE: -1,
  BEING_HELPED: 0,
  WAITING: 1,
  FIXING_QUESTION: 2,
  FROZEN: 3,
  COOLDOWN_VIOLATION: 4,
  RECEIVED_MESSAGE: 5,
});
